import React from 'react';
export function PainPoints() {
  const points = ['Buscas guías de trabajo y todo está desactualizado o no cumple las normas de seguridad.', 'Explicas cálculo de sección y caída de tensión sin ejercicios prácticos listos para el alumno.', 'Armas tus fichas de taller desde cero cada semana, robándole tiempo a tu familia.', 'Evaluaciones improvisadas sin criterios claros de corrección.', 'No hay conexión entre la teoría del tablero y lo que el alumno encuentra en una obra real.', 'Terminas el domingo a las 11 de la noche con el cursor parpadeando en un Word en blanco.'];
  return <section className="py-10 px-4 bg-brand-dark" data-id="element-81">
      <div className="max-w-xl mx-auto" data-id="element-82">
        <h2 className="text-xl md:text-2xl font-black text-center mb-6 text-white leading-tight" data-id="element-83">
          💣 ¿CUÁNTOS DOMINGOS MÁS VAS A PERDER ASÍ?
        </h2>

        <p className="text-sm md:text-base text-gray-300 mb-6 text-center leading-relaxed" data-id="element-84">
          Eres instructor en una escuela técnica o docente de taller. Enseñas
          instalaciones eléctricas, electrotecnia o formación profesional...
          <br data-id="element-85" />
          <br data-id="element-86" />
          <span className="text-brand-accent font-bold" data-id="element-87">
            Pero nadie te dio un sistema diseñado para el taller real.
          </span>
        </p>

        <div className="bg-brand-card p-5 rounded-md mb-8 border border-white/5" data-id="element-88">
          <ul className="space-y-4" data-id="element-89">
            {points.map((point, index) => <li key={index} className="flex items-start text-sm text-gray-300" data-id="element-90">
                <span className="text-red-500 mr-2 font-bold" data-id="element-91">❌</span>
                <span data-id="element-92">{point}</span>
              </li>)}
          </ul>
        </div>

        <div className="text-center mb-6" data-id="element-93">
          <p className="text-base font-bold text-white" data-id="element-94">
            👉 No es falta de vocación. Es falta de un sistema.
          </p>
        </div>

        <div className="text-center" data-id="element-95">
          <h3 className="text-lg md:text-xl font-black text-brand-accent" data-id="element-96">
            💡 ¿Y SI ESTE FUERA EL ÚLTIMO DOMINGO ASÍ?
          </h3>
        </div>
      </div>
    </section>;
}